import axios from 'axios';
import queryString from 'query-string';
import { PATH, BASE_URL } from '../../../constants/variables';

/**
 * Centralized Redo Practice functionality
 * @param {Object} component - The component instance calling this function
 * @param {number} gameNumber - The game number (3, 7, 8, 9, 10)
 * @param {Object} initialGameData - The initial game data to reset to
 * @param {Object} resetState - Additional state properties to reset
 * @param {boolean} inPlace - Whether to retake in place or navigate (default: false)
 */
export const retakeTestRound = (
  component,
  gameNumber,
  initialGameData,
  resetState = {},
  inPlace = false,
) => {
  const { history, match, location } = component.props;
  const testId = queryString.parse(location.search)['test'];

  // Call the same API as testRound function to restart the practice
  axios
    .put(`${BASE_URL}${PATH}assessments/${match.params.id}/start/`)
    .then((res) => {
      if (res.data.success) {
        // Create base reset state
        const baseResetState = {
          round: 0,
          tap: false,
          disabled: false,
          end: false,
          hasCompletedRound: false,
          answer: null,
          selectedItem: null,
          isChecked: false,
          ...resetState,
        };

        // Handle data reset - create deep copy to avoid mutation
        if (initialGameData) {
          baseResetState.data = JSON.parse(JSON.stringify(initialGameData));
        }

        // Reset game state
        component.setState(baseResetState);

        // Navigate to practice run unless doing in-place retake
        if (!inPlace) {
          history.replace(
            `/practice-run/${gameNumber}${match.params.id}?test=${testId}`,
          );
        }
      }
    })
    .catch((error) => {
      console.error('Error restarting practice round:', error);
    });
};

/**
 * Create a bound retakeTestRound function for a specific component
 * @param {Object} component - The component instance
 * @param {number} gameNumber - The game number
 * @param {Object} initialGameData - The initial game data
 * @param {Object} resetState - Additional state properties to reset
 * @param {boolean} inPlace - Whether to retake in place
 * @returns {Function} Bound retake function
 */
export const createRetakeTestRound = (
  component,
  gameNumber,
  initialGameData,
  resetState = {},
  inPlace = false,
) => {
  return () =>
    retakeTestRound(
      component,
      gameNumber,
      initialGameData,
      resetState,
      inPlace,
    );
};
